import React from 'react'

export default function NoMatchPage() {
    return <div>No page found</div>
}


